import React, { useEffect, useRef, useState, useMemo } from "react";
import {
  Avatar,
  Badge,
  DatePicker,
  Form,
  Select,
  Space,
  Spin,
  Card,
  Row,
  Col,
  Modal,
  Input,
  message,
} from "antd";
import { CSVLink } from "react-csv";
import { CALL_API } from "../../Common/api";
import { useDispatch, useSelector } from "react-redux";
import Styled from "styled-components";
import filtericon from "../../assets/images/filter-svgrepo-com (1).svg";
import ExportIcon from "../../assets/images/export-svgrepo-com (1).svg";
import { handleDownloadChart } from "../../Reusablecomponents/Export/Exportpdf";
import StyledTable from "../../Reusablecomponents/UITable/UITable";
import { ShipmentType, TripTypeEnum } from "../../Common/constant";
import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
  BarChart,
  Bar,
  LabelList,
} from "recharts";
import ReusablePagination from "../../Reusablecomponents/ReusablePagination";
import { ButtonFilled } from "../../Reusablecomponents/UIButtons";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
dayjs.extend(utc);
dayjs.extend(timezone);

const Styledashboard = Styled.div`
@media (min-width: 320px) and (max-width: 480px) {
 .total{
  display: flex;
 justify-content: space-between;
  align-items: center;
    width: 100%;
    flex-direction: column;
 }
 .head{
  fontSize:12px!important;
 }
 
 
}
.Custom {
  display: flex;
  align-items: center;
      justify-content: flex-end; /* Pushes content to the right */
  margin-bottom: 20px;
  gap: 20px;
}
    .head2 {
    color: #5f6d8c;
  }
      .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .Custom {
    display: flex;
    align-items: center;
    gap: 20px;
  }
    .dropstyle {
    margin-top: 20px !important;
    width: 251px !important;
  }
  .dropstyle1 {
    height: 36px;
    width: 251px !important;
  }
     .chart-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;
  }
    .timing-center {
    // margin-top: 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    }
  .head {
  margin-bottom: 5px;
  color: #5f6d8c;
  height: 29px;
  }
  .header-container {
  display: flex;
  justify-content: space-between; 
  align-items: center; 
  width: 100%;
}
  .consignment-value{
  color: #1F243B;
  font-size: 24px;
  font-weight: 600;
  }
  .carbon-title{
  color: #1F243B;
  font-size: 16px;
  font-weight: 500;
  }
  .total-mins{
  color: #363636;
    font-size: 20px;
  font-weight: 600;
  }
    @media (max-width: 480px) {
    .Custom {
      flex-direction: column; /* Stack items vertically */
      align-items: flex-start; /* Align items to the left */
      gap: 10px; /* Adjust spacing between elements */
    }

    .dropstyle1 {
      flex: 1 !important; /* Allow dropdowns to expand */
      width: unset !important; /* Remove fixed width */
      width: 100% !important;
    }
    .dropstyle {
      flex: 1 !important; /* Allow dropdowns to expand */
      min-width: unset !important; /* Remove fixed width */
      width: 100% !important;
    }

    .badg {
      margin-top: 10px;
    }
    .hover-image,
    .badg {
      width: auto; /* Ensure these items don't stretch unnecessarily */
    }
 .tooltipContainer {
    position: relative ;
    display: inline-block ;
    textAlign: center;
  }
  .arrowDown {
    position: absolute;
    top: -8px ;
    left: 50% ;
    transform: translateX(-50%);
    width: 0;
    height: 0;
    borderLeft: 8px solid transparent ;
    borderRight: 8px solid transparent ;
    borderBottom: 8px solid #ffffff ;
    zIndex: 1;
  }
  .tooltipContent: {
    background:  #ffffff;
    color: #333;
    padding: 10px 12px;
    borderRadius: 8px;
    boxShadow: 0 2px 10px rgba(0,0,0,0.15);
    fontSize: 13px;
    minWidth: 100px;
    zIndex: 2;
  }
  .label {
    fontWeight: bold;
    marginBottom: 5px;
  }
  item {
    display: flex;
    justifyContent: space-between;
    gap: 4px;
  }
    /* Place .badg and .hover-image in one row */
    .badg-hover-wrapper {
      display: flex;
      justify-content: flex-start; /* Align items to the left */
      align-items: center; /* Vertically center elements */
      gap: 10px; /* Add spacing between .badg and .hover-image */
      width: 100%; /* Take full width */
    }
  }
  @media (max-width: 1024px) {
    .legend-image {
      display: none;
    }
  }
  `;
const CarbonReport = () => {
  const [filterValues, setFilterValues] = useState({
    consignee: "",
    transporter: "",
    consignor: "",
    shipment: "",
    code: "",
    triptype: "",
    vehicle: "",
  });
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);

  const consignerList = useSelector(
    (state) => state?.authTracking?.consignerList,
  );
  const transporterList = useSelector(
    (state) => state?.authTracking?.transporterList,
  );
  const consigneeList = useSelector(
    (state) => state?.authTracking?.consigneeList,
  );
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const exportAllowed = useMemo(
    () => hasPermission("CONT_RPT", "EX"),
    [reduxPermissions],
  );
  const vehicleList = useSelector((state) => state?.authTracking?.vehicleList);
  const [currentPage, setCurrentPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);
  const [filterCount, setFilterCount] = useState(0);
  const [filterform] = Form.useForm();
  const [filterModalOpen, setFilterModalOpen] = useState(false);
  const [duration, setDuration] = useState("current_month");
  const [selectedDate, setSelectedDate] = useState([null, null]);
  const [carbonChart, setCarbonChart] = useState([]);
  const [carbonTable, setCarbonTable] = useState([]);
  const [CSVList, setCSVList] = useState([]);
  const [CSVLoader, setCSVLoader] = useState(false);
  const csvLinkEl = useRef();

  const { Option } = Select;
  const { RangePicker } = DatePicker;
  const Duration = [
    { label: "Current Month", value: "current_month" },
    { label: "Current Year", value: "current_year" },
    { label: "Last Month", value: "last_month" },
    { label: "Today", value: "today" },
  ];
  const handlechange = (value) => {
    setDuration(value);
  };
  const handlechangefordate = (date, dateString) => {
    setSelectedDate(date);
  };
  const [isModalOpen, setIsModalOpen] = useState(false);
  const showModal = () => {
    setIsModalOpen(true);
  };

  const handlePageChange = (page, pageSize) => {
    setCurrentPage(page);
    setPageSize(pageSize);
  };

  const handlePageSizeChange = (value) => {
    setPageSize(value);
    setCurrentPage(1);
  };
  //customized Tooltip
  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div className="tooltipContainer">
          <div className="arrowDown" />
          <div className="tooltipContent">
            <div className="label">{label}</div>
            {payload.map((entry, index) => (
              <div key={index} className="item">
                {/* <span>{entry.name}:</span> */}
                <strong> {entry.value}</strong>
              </div>
            ))}
          </div>
        </div>
      );
    }
    return null;
  };

  const getCarbonCharts = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getCarbonReportCharts?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format("YYYY-MM-DD")}`,
        {
          TRIPTYPE: filterValues?.triptype || 0,
          VEHID: filterValues?.vehicle || "",
          CUST: filterValues?.consignor || 0,
          SHIPPER: filterValues?.transporter || 0,
          RECEIVER: filterValues?.consignee || 0,
          TRIPCODE: filterValues?.code || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );
      setLoading(false);
      setCarbonChart(data);
    } catch (error) {
      console.error("[getCarbonCharts] error -->", error);
    }
  };

  const getCarbonTable = async () => {
    setLoading(true);
    try {
      const { data } = await CALL_API(
        "POST",
        `/contReport/getCarbonReportPagination?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=${currentPage}&PageSize=${pageSize}`,
        {
          TRIPTYPE: filterValues?.triptype || 0,
          VEHID: filterValues?.vehicle || "",
          CUST: filterValues?.consignor || 0,
          SHIPPER: filterValues?.transporter || 0,
          RECEIVER: filterValues?.consignee || 0,
          TRIPCODE: filterValues?.code || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );
      setLoading(false);
      setCarbonTable(data);
      setTotal(data?.totalCount || 0);
    } catch (error) {
      console.error("[getCarbonTable] error -->", error);
    }
  };

  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getCarbonCharts();
    }
  }, [filterValues, selectedDate]);
  useEffect(() => {
    if (selectedDate && selectedDate[0] && selectedDate[1]) {
      getCarbonTable();
    }
  }, [filterValues, selectedDate, currentPage, pageSize]);

  useEffect(() => {
    let startDate = null;
    let endDate = null;

    if (duration === "today") {
      startDate = dayjs();
      endDate = dayjs();
    } else if (duration === "current_month") {
      startDate = dayjs().startOf("month");
      endDate = dayjs().endOf("month");
    } else if (duration === "last_month") {
      startDate = dayjs().subtract(1, "month").startOf("month");
      endDate = dayjs().subtract(1, "month").endOf("month");
    } else if (duration === "current_year") {
      startDate = dayjs().startOf("year");
      endDate = dayjs().endOf("year");
    }

    if (startDate && endDate) {
      setSelectedDate([startDate, endDate]);
    }
  }, [duration]);

  const apiData = carbonChart?.CarbonFootprintConsignee?.recordset || [];

  const data = apiData.map((item) => ({
    name: item.DATA, // consignee name
    uv: item.VAL, // carbon footprint value
  }));
  const apiData1 = carbonChart?.carboonfootprintVehicle?.recordset || [];

  const data1 = apiData1.map((item) => ({
    name: item.DATA, // vehicle number
    uv: item.VAL, // carbon footprint value
  }));
  const formatMinutes = (value) => {
    if (value == null || isNaN(value)) return "-";
    const hours = Math.floor(value / 60);
    const minutes = value % 60;
    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };
  const prepareCSV = async () => {
    try {
      setCSVLoader(true);
      const { data } = await CALL_API(
        "POST",
        `/contReport/getCarbonReportPagination?MCID=${
          userInfo?.MCID
        }&startDate=${dayjs(selectedDate[0]).format(
          "YYYY-MM-DD",
        )}&endDate=${dayjs(selectedDate[1]).format(
          "YYYY-MM-DD",
        )}&PageNumber=1&PageSize=${total}`,
        {
          TRIPTYPE: filterValues?.triptype || 0,
          VEHID: filterValues?.vehicle || "",
          CUST: filterValues?.consignor || 0,
          SHIPPER: filterValues?.transporter || 0,
          RECEIVER: filterValues?.consignee || 0,
          TRIPCODE: filterValues?.code || "",
          ShipmentType: filterValues?.shipment || 0,
        },
      );

      if (data?.totalCount > 0) {
        // Apply sorting to match table sort order
        const sortedData = applySorting(data?.CarbonTable);
        setCSVList(
          sortedData?.map((item) => ({
            "Trip Code": item.TRIPCODE || "-",
            "Start Date": item.PickupDateTime
              ? dayjs(item.PickupDateTime).format("DD/MM/YYYY")
              : "-",
            Consignor: item.CUSTNAME || "-",
            Consignee: item.RECNAME || "-",
            Transporter: item.SUPNAME || "-",
            "Carbon Footprint (KgCo2)": item.CarbonFootprint || "-",
            Vehicle: item.VEHREGNO,
            "Trip Type": item.TRIPTYPE
              ? item.TRIPTYPE === 1
                ? "Local"
                : "Safari"
              : "-",
            "ODO(KMS)": item.GPSKMS || "-",
            "Avg Trip Time": formatMinutes(item.AVGTRIPTIME) || "-",
          })),
        );

        setTimeout(() => {
          csvLinkEl.current?.link?.click();
        });
      } else {
        message.error("No data available to download.");
      }
    } catch (error) {
      console.error("CSV export error -->", error);
    } finally {
      setCSVLoader(false);
    }
  };

  const VerticalChart = ({ data, width, height, barColor, dataKey, type }) => {
    return (
      <ResponsiveContainer width={width} height={height}>
        <BarChart
          layout="vertical"
          margin={{ top: 10, right: 50, left: -20, bottom: 10 }}
          barSize={25}
          data={data}
        >
          <CartesianGrid vertical={false} horizontal={false} />
          <XAxis
            type="number"
            axisLine={false}
            tickLine={false}
            domain={[0, 20]}
            // ticks={[0, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20]}
            interval={0}
            tick={{
              fontSize: 12, // Adjust font size if needed
              textAnchor: "start", // Align text to end for better readability
            }}
            tickFormatter={(value) => Math.round(value)}
          />
          <YAxis
            type="category"
            dataKey="Vehicle_No"
            axisLine={false}
            tickLine={false}
            width={150}
            tick={{
              fontSize: 12, // Adjust font size if needed
              textAnchor: "end", // Align text to end for better readability
            }}
            label={{
              value: "(KgCO2)", // Text you want to display
              angle: 0, // Keep the text horizontal
              position: "bottom", // Position it below the Y-axis labels
              offset: 8, // Adjust spacing
              dx: 35, // Move the text slightly to the right

              style: { fontSize: 12, fill: "#363636", fontWeight: 500 }, // Customize text appearance
            }}
          />
          <Tooltip content={<CustomTooltip />} />
          {/* <Legend /> */}
          <Bar
            dataKey="value"
            fill={barColor}
            radius={5}
            style={{ cursor: "pointer" }}
          >
            <LabelList
              content={({ x, y, width, value }) => (
                <text
                  x={x + width + 5} // 5px padding to the right of the bar
                  y={y + 14} // vertically center the label in the bar
                  fill="#000"
                  fontSize={12}
                >
                  {Math.round(value)}
                </text>
              )}
            />
          </Bar>
        </BarChart>
      </ResponsiveContainer>
    );
  };

  const [tableSort, setTableSort] = useState({
    field: null,
    order: null, // 'ascend' or 'descend'
  });

  // Helper function to sort data based on current sort state
  const applySorting = (data) => {
    if (!tableSort.field || !data || data.length === 0) {
      return data;
    }

    const sorted = [...data].sort((a, b) => {
      let aVal = a[tableSort.field];
      let bVal = b[tableSort.field];

      // Handle numeric fields
      if (["TRIPTYPE", "GPSKMS", "CarbonFootprint"].includes(tableSort.field)) {
        aVal = aVal || 0;
        bVal = bVal || 0;
        const result = aVal - bVal;
        return tableSort.order === "ascend" ? result : -result;
      }

      // Handle string fields
      aVal = aVal || "";
      bVal = bVal || "";
      const result = (aVal + "").localeCompare(bVal + "");
      return tableSort.order === "ascend" ? result : -result;
    });

    return sorted;
  };
  const OfficeColumn = [
    {
      title: "Trip Code",
      dataIndex: "TRIPCODE",
      key: "TRIPCODE",
      sorter: (a, b) => (a.TRIPCODE || "").localeCompare(b.TRIPCODE || ""),
      sortOrder: tableSort.field === "TRIPCODE" ? tableSort.order : null,
    },
    {
      title: "Consignor",
      dataIndex: "CUSTNAME",
      key: "CUSTNAME",
      sorter: (a, b) => (a.CUSTNAME || "").localeCompare(b.CUSTNAME || ""),
      sortOrder: tableSort.field === "CUSTNAME" ? tableSort.order : null,
    },
    {
      title: "Transporter",
      dataIndex: "SUPNAME",
      key: "SUPNAME",
      sorter: (a, b) => (a.SUPNAME || "").localeCompare(b.SUPNAME || ""),
      sortOrder: tableSort.field === "SUPNAME" ? tableSort.order : null,
    },
    {
      title: "Consignee",
      dataIndex: "RECNAME",
      key: "RECNAME",
      sorter: (a, b) => (a.RECNAME || "").localeCompare(b.RECNAME || ""),
      sortOrder: tableSort.field === "RECNAME" ? tableSort.order : null,
    },
    {
      title: "Start Date",
      dataIndex: "PickupDateTime",
      key: "PickupDateTime",
      sorter: (a, b) =>
        (a.PickupDateTime || "").localeCompare(b.PickupDateTime || ""),
      sortOrder: tableSort.field === "PickupDateTime" ? tableSort.order : null,
      render: (value) => {
        if (!value) return "-";
        const dt = dayjs.utc(value).tz("Africa/Nairobi");
        return `${dt.format("DD/MM/YYYY")}`;
      },
    },
    {
      title: "Vehicle",
      dataIndex: "VEHREGNO",
      key: "VEHREGNO",
      sorter: (a, b) => (a.VEHREGNO || "").localeCompare(b.VEHREGNO || ""),
      sortOrder: tableSort.field === "VEHREGNO" ? tableSort.order : null,
    },
    {
      title: "Carbon Footprint (KgCO2)",
      dataIndex: "CarbonFootprint",
      key: "CarbonFootprint",
      sorter: (a, b) => (a.CarbonFootprint || "") - (b.CarbonFootprint || ""),
      sortOrder: tableSort.field === "CarbonFootprint" ? tableSort.order : null,
    },
    {
      title: "Trip Type",
      dataIndex: "TRIPTYPE",
      key: "TRIPTYPE",
      sorter: (a, b) => (a.TRIPTYPE || 0) - (b.TRIPTYPE || 0),
      sortOrder: tableSort.field === "TRIPTYPE" ? tableSort.order : null,
      render: (type) => (type === 1 ? "Local" : "Safari"),
    },
    {
      title: "ODO Kms",
      dataIndex: "GPSKMS",
      key: "GPSKMS",
      sorter: (a, b) => (a.GPSKMS || 0) - (b.GPSKMS || 0),
      sortOrder: tableSort.field === "GPSKMS" ? tableSort.order : null,
    },
  ];
  const itemsPerPage = 10;
  const maxPage = Math.floor(data1?.length / itemsPerPage);

  const handlePrev = () => {
    setCurrentPage((prev) => Math.max(prev - 1, 0));
  };

  const handleNext = () => {
    setCurrentPage((prev) => Math.min(prev + 1, maxPage));
  };

  const paginatedData = data1.slice(
    currentPage * itemsPerPage,
    (currentPage + 1) * itemsPerPage,
  );

  return (
    <>
      <Styledashboard>
        <div
          className="total"
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center", // Align items vertically
            width: "100%",
          }}
        >
          {/* Overview on the left */}
          <div className="head" style={{ flex: 1 }}>
            Total Carbon Footprint:{" "}
            {carbonChart?.Totalcarbonfootprint?.recordset?.[0]?.TotalCb} KgCO2
          </div>

          {/* Duration and Date Range on the right */}
          <div className="Custom" style={{ display: "flex", gap: "20px" }}>
            <div className="dropstyle">
              <Form.Item
                label=""
                name="dropdown"
                rules={[
                  { required: true, message: "Please select an option!" },
                ]}
              >
                <Select
                  placeholder="Custom Range"
                  onChange={handlechange}
                  defaultValue={duration}
                  className="plc"
                >
                  {Duration.map((item) => (
                    <Option key={item.value} value={item.value}>
                      {item.label}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </div>
            <div className="dropstyle1">
              <Space direction="vertical" size={12}>
                <RangePicker
                  value={selectedDate}
                  onChange={handlechangefordate}
                />
              </Space>
            </div>
            <div>
              <Badge
                count={filterCount}
                className="badg"
                onClick={() => setFilterModalOpen(true)}
              >
                <Avatar
                  shape="circle"
                  size="medium"
                  src={filtericon}
                  className="filterstyle"
                />
              </Badge>
            </div>
          </div>
        </div>
        <div>
          <Spin spinning={loading}>
            <div id="Export Chart1">
              <Card
                style={{
                  width: "100%",
                  height: "100%",
                  overflowX: "auto",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <p className="carbon-title">Carbon Footprint by Vehicle</p>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "23px",
                    }}
                  >
                    <LeftOutlined
                      style={{ cursor: "pointer" }}
                      onClick={handlePrev}
                      disabled={currentPage === 0}
                    />
                    <RightOutlined
                      style={{ cursor: "pointer" }}
                      onClick={handleNext}
                      disabled={currentPage === maxPage - 1}
                    />
                    {/* <Tooltip title={!exportAllowed ? "No permission" : "Export"}> */}
                      <img
                        src={ExportIcon}
                        alt="Upload Icon"
                        className="hover-image"
                        onClick={() => {
                          if (!exportAllowed) return;
                          handleDownloadChart(
                            "Export Chart1",
                            "Carbon Footprint by Vehicle",
                          );
                        }}
                        style={{
                          cursor: exportAllowed ? "pointer" : "not-allowed",
                        }}
                      />
                    {/* </Tooltip> */}
                  </div>
                </div>

                {/* Inner container with a wider width */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <ResponsiveContainer width="100%" height={400}>
                    <AreaChart
                      data={paginatedData}
                      margin={{ top: 20, right: 50, left: 10, bottom: 20 }}
                      style={{ cursor: "pointer" }}
                    >
                      <defs>
                        <linearGradient
                          id="colorUv"
                          x1="0"
                          y1="0"
                          x2="0"
                          y2="1"
                        >
                          <stop
                            offset="5%"
                            stopColor="rgba(37, 169, 114, 1)"
                            stopOpacity={0.8}
                          />
                          <stop
                            offset="95%"
                            stopColor="rgba(217, 217, 217, 0)"
                            stopOpacity={0.8}
                          />
                        </linearGradient>
                      </defs>
                      <XAxis
                        dataKey="name"
                        tickLine={false}
                        interval={0}
                        tick={{
                          textAnchor: "start", // Center align text
                          fontSize: 11,
                        }}
                      />
                      <YAxis
                        axisLine={false}
                        tickLine={false}
                        tickFormatter={(value) => Math.round(value)}
                      />

                      <Tooltip content={<CustomTooltip />} />
                      <Area
                        type="monotone"
                        dataKey="uv"
                        stroke="rgba(37, 169, 114, 1)"
                        fill="url(#colorUv)"
                      />
                    </AreaChart>
                  </ResponsiveContainer>
                </div>
              </Card>
            </div>
          </Spin>
        </div>
        <br />
        <div id="Export Chart2">
          <Spin spinning={loading}>
            <Card style={{ overflowX: "auto" }}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p className="carbon-title">Carbon Footprints by Consignee</p>
                <div
                  style={{ display: "flex", alignItems: "center", gap: "10px" }}
                >
                  {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                    <img
                      src={ExportIcon}
                      alt="Upload Icon"
                      className="hover-image"
                      onClick={() => {
                        if (!exportAllowed) return;
                        handleDownloadChart(
                          "Export Chart2",
                          "Carbon Footprints by Consignee",
                        );
                      }}
                      style={{
                        cursor: exportAllowed ? "pointer" : "not-allowed",
                      }}
                    />
                  {/* </Tooltip> */}
                </div>
              </div>
              <div
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "center",
                }}
              >
                <div
                  style={{
                    width: "100%",
                    height: "400px",
                  }}
                  className="chart-container"
                >
                  <VerticalChart
                    data={data?.map((item, index) => ({
                      Vehicle_No: item.name,
                      value: item.uv,
                    }))}
                    width="100%"
                    height={400}
                    barColor="blue"
                    dataKey="uv"
                  />
                </div>
              </div>
            </Card>
          </Spin>
        </div>
        <br /> <br />
        <div className="header">
          <div className="head2">
            <p>{total} Carbon Footprints</p>
          </div>
          <div className="Custom2">
            <Spin spinning={CSVLoader}>
              {/* <Tooltip title={!exportAllowed ? "No permission" : ""}> */}
                <img
                  src={ExportIcon}
                  style={{ cursor: exportAllowed ? "pointer" : "not-allowed" }}
                  alt="Export"
                  className="hoverimage1"
                  onClick={() => {
                    if (!exportAllowed) return;
                    prepareCSV();
                  }}
                />
              {/* </Tooltip> */}
            </Spin>
            <CSVLink
              data={CSVList}
              filename={"CarbonfootprintReport.csv"}
              asyncOnClick={true}
              ref={csvLinkEl}
            />
          </div>
        </div>
        <Spin spinning={loading}>
          {carbonTable?.CarbonTable?.length > 0 && (
            <StyledTable
              dataSource={carbonTable?.CarbonTable}
              columns={OfficeColumn}
              pagination={false}
              onChange={(pagination, filters, sorter) => {
                setTableSort({
                  field: sorter.field,
                  order: sorter.order,
                });
              }}
            />
          )}
        </Spin>
        <ReusablePagination
          pageSize={pageSize}
          handlePageSizeChange={handlePageSizeChange}
          currentPage={currentPage}
          total={total}
          handlePageChange={handlePageChange}
        />
      </Styledashboard>
      <Modal
        open={filterModalOpen}
        onCancel={() => setFilterModalOpen(false)}
        width={900}
        footer={
          <ButtonFilled
            onClick={() => {
              filterform.resetFields();
              setFilterValues({});
            }}
          >
            {" "}
            Clear All{" "}
          </ButtonFilled>
        }
      >
        <Row>
          <Col xl={24} xs={{ span: 24, order: 2 }}>
            <div className="container_for_kpi_filter">
              <h6 className="Filter_for_clickablerow">
                Filter ({filterCount})
              </h6>
              {/* <p className="Filter_for_Result">4 Result Found </p> */}
            </div>
          </Col>
        </Row>
        <Form
          form={filterform}
          layout="vertical"
          onValuesChange={(value, allvalues) => {
            setFilterCount();
            setFilterValues(allvalues);
          }}
          //  initialValues={formValues}
        >
          <Row gutter={16}>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignor" name="consignor">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consignerList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Consignee" name="consignee">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={consigneeList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Transporter" name="transporter">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={transporterList?.map((item) => ({
                    label: item.Name,
                    value: item.ID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Trip Type" name="triptype">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={TripTypeEnum?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Shipment Type" name="shipment">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={ShipmentType?.map((item) => ({
                    label: item.name,
                    value: item.value,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>
            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Vehicle No." name="vehicle">
                <Select
                  className="w-100"
                  showSearch
                  optionFilterProp="children"
                  options={vehicleList?.map((item) => ({
                    label: item.REGNO,
                    value: item.VEHID,
                  }))}
                  filterOption={(input, option) =>
                    option?.label?.toLowerCase().includes(input.toLowerCase())
                  }
                  allowClear
                  // suffixIcon={<SearchOutlined className="search_icon" />}
                />{" "}
              </Form.Item>
            </Col>

            <Col xs={24} sm={24} md={6}>
              <Form.Item label="Trip" name="code">
                <Input placeholder="" className="rounded-pill" />
              </Form.Item>
            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
};

export default CarbonReport;
